'use strict';

(function () {
    //prepare bool flags

    var firstVideoIsLoaded = false,
        isTransitioning = false,
        shouldTransition = false,
        isPlaying = false;

    //prepare arrays
    var slideList = [],
        textList = [],
        periodList = [];

    //prepare video vars
    var currentVideo = null,
        nextVideo = null;

    //prepare slide vars
    var currentSlide = null,
        nextSlide = null;

    //prepare text vars
    var currentText = null,
        nextText = null;

    var finalPeriod = null;

    var smallText = function smallText() {
        return document.getElementById('slide-label');
    };

    var isInViewPort = function isInViewPort(hero) {
        var rect = hero.getBoundingClientRect();

        return rect.top >= 0 || rect.left >= 0 || rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) || rect.right <= (window.innerWidth || document.documentElement.clientWidth);
    };

    var removeSlideClasses = function removeSlideClasses() {
        getSlideList().map(function (el, i) {
            el.classList.remove('slide--current-slide');
            el.classList.remove('slide--next-slide');
        });
    };

    var removeTextClasses = function removeTextClasses() {
        if (getCurrentText() !== null) {
            getCurrentText().lines.map(function (line, i) {
                if (periodList[i] === line.querySelector(".slide-text--period")) {
                    line.removeChild(periodList[i]);
                }
            });
            finalPeriod = null;
            periodList = [];
            getCurrentText().revert();
        };
        getTextList().map(function (el, i) {
            el.classList.remove('slide-text--active');
            el.classList.remove('slide-text--next');
        });
    };

    //setters
    var setCurrentSlide = function setCurrentSlide(slide) {
        removeSlideClasses();
        currentSlide = slide;
        currentSlide.classList.add("slide--current-slide");
        setCurrentVideo(currentSlide.querySelector('video'));
        setNextSlide(currentSlide);
    };

    var setNextSlide = function setNextSlide(slide) {
        var currentIndex = getSlideList().indexOf(slide);
        if (currentIndex + 1 >= getSlideList().length) {
            nextSlide = getSlideList()[0];
        } else {
            nextSlide = getSlideList()[currentIndex + 1];
        }
        nextSlide.classList.add("slide--next-slide");
        setNextVideo(nextSlide.querySelector('video'));
    };

    var setSlideList = function setSlideList() {
        slideList = [].slice.call(document.querySelectorAll('.slide'));
    };

    var setTextList = function setTextList() {
        textList = [].slice.call(document.querySelectorAll('.slide-text--large'));
    };

    var setCurrentText = function setCurrentText(text) {
        removeTextClasses();
        currentText = text;
        currentText.className += " slide-text--active";
        currentText = new SplitText(currentText, { type: "words, chars, lines", linesClass: "slide-text--line slide-text--line-++", wordsClass: "slide-text--word", charsClass: "slide-text--char" });
        periodList = currentText.lines.map(function (line, i) {
            var period = document.createElement("div");
            period.classList.add('slide-text--period-' + i, 'slide-text--period');
            line.appendChild(period);
            return period;
        });
        setNextText(text);
    };

    var setNextText = function setNextText(text) {
        var currentIndex = getTextList().indexOf(text);
        if (currentIndex + 1 >= getTextList().length) {
            nextText = getTextList()[0];
        } else {
            nextText = getTextList()[currentIndex + 1];
        }
        nextText.classList.add("slide-text--next");
    };

    var setCurrentVideo = function setCurrentVideo(video) {
        currentVideo = video;
    };

    var setNextVideo = function setNextVideo(video) {
        nextVideo = video;
    };

    //getters
    var getSlideList = function getSlideList() {
        return slideList;
    };
    var getTextList = function getTextList() {
        return textList;
    };
    var getPeriodList = function getPeriodList() {
        return periodList;
    };

    var getCurrentSlide = function getCurrentSlide() {
        return currentSlide;
    };
    var getNextSlide = function getNextSlide() {
        return nextSlide;
    };

    var getCurrentVideo = function getCurrentVideo() {
        return currentVideo;
    };
    var getNextVideo = function getNextVideo() {
        return nextVideo;
    };

    var getCurrentText = function getCurrentText() {
        return currentText;
    };
    var getNextText = function getNextText() {
        return nextText;
    };

    var getCurrentTextOffsetY = function getCurrentTextOffsetY(text) {
        return text.elements[0].offsetHeight;
    };

    //other functions

    var playVideo = function playVideo(video) {
        if (video.classList.contains('video--is-not-yet-loaded')) {
            video.classList.remove('video--is-not-yet-loaded');
            video.classList.add('video--is-loaded');
        }
        video.play();
    };

    var slideTransition = function slideTransition() {
        isTransitioning = true;

        var transitionTimeline = new TimelineMax({
            onComplete: function onComplete() {
                isTransitioning = false;
                getCurrentVideo().currentTime = 0;
                setCurrentSlide(getNextSlide());

                setCurrentText(getNextText());
                animateLargeTextOn(getCurrentText());
            }
        });

        var totalDuration = 1.0;
        var durationPerCharacter = .66;
        var delayPerCharacter = (totalDuration - durationPerCharacter) / getCurrentText().chars.length;

        transitionTimeline.staggerTo(getCurrentText().chars, .66, {
            x: -10,
            autoAlpha: 0,
            ease: Quint.easeIn
        }, delayPerCharacter).to(finalPeriod, .66, {
            autoAlpha: 0,
            ease: Quint.easeIn
        }, .33).to(getCurrentSlide(), 1, {
            x: "-100%",
            force3D: "auto",
            clearProps: "all",
            ease: Quint.easeInOut
        }, .33).to(getCurrentVideo(), 1, {
            x: "-20%",
            force3D: "auto",
            clearProps: "all",
            ease: Quint.easeInOut
        }, .33).to(getNextSlide(), 1, {
            x: "0",
            force3D: "auto",
            clearProps: "all",
            ease: Quint.easeInOut,
            onStart: function onStart() {
                playVideo(getNextVideo());
            }
        }, .33);

        return transitionTimeline;
    };

    var animateSmallTextOn = function animateSmallTextOn() {
        var slideLabel = document.getElementById('slide-label');

        if (!slideLabel)
            return null

        var splitSmallText = new SplitText(slideLabel, { type: 'words' })

        var words = splitSmallText.words;

        var smallTextTimeline = new TimelineMax({
            onComplete: function onComplete() {
                splitSmallText.revert();
            }
        });

        TweenMax.set(slideLabel, { autoAlpha: 1 });
        TweenMax.set(words, { autoAlpha: 0, y: 25 });

        smallTextTimeline.staggerTo(words, .75, { autoAlpha: 1, y: 0, ease: Quint.easeOut }, 0.2);

        return smallTextTimeline;
    };

    var animateLargeTextOn = function animateLargeTextOn(text) {
        var largeTextTimeline = new TimelineMax();
        var chars = text.chars;

        var durationPerCharacter = .66;
        var delayPerCharacter = .06;

        var totalDuration = delayPerCharacter * chars.length + durationPerCharacter;

        TweenMax.set(text.elements[0], { autoAlpha: 1 });
        TweenMax.set(chars, { autoAlpha: 0, x: 50 });

        largeTextTimeline.to(document.querySelector(".slide-content--inner"), 1, { height: getCurrentTextOffsetY(text), ease: Quint.easeOut }, 0).staggerTo(chars, durationPerCharacter, {
            autoAlpha: 1,
            x: 0,
            ease: Quint.easeOut
        }, delayPerCharacter, .25).add(animatePeriods(text, totalDuration), .25);

        return largeTextTimeline;
    };

    var animatePeriods = function animatePeriods(text, totalDuration) {
        var lineArrLen = [].slice.call(text.lines).length;
        var periodsTimeline = new TimelineMax();
        text.lines.map(function (line, i) {

            var periodTimeline = new TimelineMax();
            var period = getPeriodList()[i];

            var basePeriodScale = 0.14;
            var periodScaleY = basePeriodScale;
            var periodScaleX = line.clientHeight * basePeriodScale / line.clientWidth;

            if (i === lineArrLen - 1) {
                periodTimeline.to(period, totalDuration * .46, {
                    scaleX: 1,
                    ease: Quad.easeOut,
                    onComplete: function onComplete() {
                        TweenMax.set(period, { transformOrigin: '100% 0% ' });
                    }
                }, 0).to(period, totalDuration * .46, { scaleX: periodScaleX, ease: Quad.easeIn }, totalDuration * .6).to(period, totalDuration * .38, { scaleY: periodScaleY, ease: Quad.easeIn, y: 45 * periodScaleY + "%" }, totalDuration * .8).to(period, totalDuration * .61, { x: 105 * periodScaleX + "%" }, totalDuration * .3);
                finalPeriod = period;
            } else {
                periodTimeline.to(period, totalDuration * .46, {
                    scaleX: 1,
                    ease: Quad.easeOut,
                    onComplete: function onComplete() {
                        TweenMax.set(period, { transformOrigin: '100% 0%' });
                    }
                }, 0).to(period, totalDuration * .46, { scaleX: 0, ease: Quad.easeIn }, totalDuration * .6).to(period, totalDuration * .61, { x: 105 * periodScaleX + "%" }, totalDuration * .3);
            }

            periodsTimeline.add(periodTimeline, i * (totalDuration * .25));
        });

        return periodsTimeline;
    };

    var isReady = function isReady(slide) {
        if (slide.querySelector('video') !== undefined) {
            return slide.querySelector('video').readyState === 4;
        }
    };

    var checkVideoReadyStates = function checkVideoReadyStates() {
        //loading only the first guy
        if (isReady(getSlideList()[0])) {
            firstVideoIsLoaded = true;
            isPlaying = true;
            animateSmallTextOn();
            playVideo(getSlideList()[0].querySelector('video'));
            animateLargeTextOn(getCurrentText());
        };
    };

    //load all videos
    var loadAllVideos = function loadAllVideos(index) {
        if (index > getSlideList().length - 1) {
            return;
        }

        var videoToLoad = getSlideList()[index].querySelector('video');

        var poster = videoToLoad
            && videoToLoad.getAttribute('data-poster')

        var src = videoToLoad
            && videoToLoad.getAttribute('data-src')

        if (poster
                && poster !== videoToLoad.getAttribute('poster'))
            videoToLoad.setAttribute('poster', poster);

        if (src
                && src !== videoToLoad.getAttribute('src'))
            videoToLoad.setAttribute('src', src)

        if (videoToLoad)
            videoToLoad.load();

        //update index
        index++;

        videoToLoad.oncanplaythrough = function () {
            if (!firstVideoIsLoaded) {
                firstVideoIsLoaded = true;
                animateSmallTextOn();
                playVideo(this);
                animateLargeTextOn(getCurrentText());
            }
            if (index <= getSlideList().length - 1 && !isReady(getSlideList()[index])) {
                loadAllVideos(index);
            }
            this.oncanplaythrough = null;
        };

        //recursively call loadAllVideos until no more videos can be loaded
    };

    var setup = function setup() {
        setSlideList();
        setTextList();
        setCurrentSlide(getSlideList()[0]);
        setCurrentText(getTextList()[0]);

        //this method triggers the whole thing
        loadAllVideos(0);
        window.requestAnimationFrame(tick);
    };

    //setup requestAnimationFrame event loop
    var start = true;
    var videosReady = false;
    var tick = function tick(timestamp) {

        if (getCurrentVideo() !== null && isInViewPort(document.getElementById('video-header'))) {
            var percentProgress = getCurrentVideo().currentTime / getCurrentVideo().duration;
            if (!isNaN(percentProgress) && percentProgress > .85 && !isTransitioning) {
                slideTransition();
            }
        }

        window.requestAnimationFrame(tick);
    };

    window.addEventListener('load', () => {
        setup()
    })
})();
